import { mapGetters, mapActions, mapMutations } from "vuex";
import uuid from "uuid/v1";
import { DefaultPaymentHandler } from "../../../api/payment/DefaultPaymentHandler.js";
import { storeCard } from "../../../api/services/userService";
import { $$ } from "./../../OO_jquery";
export default {
  computed: {
    ...mapGetters([
      "user",
      "dbuser",
      "giftCartValue",
      "viewConfig",
      "giftIsDelivery",
      "isGift",
      "currentStoreDoc",
      "mobileStyles",
      "giftTotalPrice",
      "getGiftSurchargeAmount",
      "giftUsedCoupons",
      "buttonStyles",
      "currencySign",
    ]),
    orderType() {
      return 10;
    },
    holder() {
      var firstName = this.detailModel.FirstName || "";
      var lastName = this.detailModel.LastName || "";
      return firstName.trim() + " " + lastName.trim();
    },
    showPayment() {
      return this.giftTotalPrice > 0;
    },
  },

  methods: {
    ...mapActions(["clearGiftCart", "signUserUp", "signUserIn"]),
    ...mapMutations(["setStoreLoaded"]),
    saveCredit() {
      this.saveCard = true;
    },
    saveUser(val) {
      this.registerNew = val;
    },

    deliveryMode() {
      this.isDelivery = true;
      this.giftIsDelivery(true);
    },
    setUserIsExist(value) {
      this.userIsExist = value;
    },
    placeOrder() {
      let cms = [];
      if (this.$refs.myDetails) {
        let p1 = this.$refs.myDetails.validate();
        cms.push(p1);
      }
      if (this.paymentMethod == 1 && this.$refs.payment) {
        let p2 = this.$refs.payment.validate();
        cms.push(p2);
        let p22 = this.$refs.payment.cardInfoValidate();
        if (p22) cms.push(p22);
      }
      var that = this;
      Promise.all(cms).then((values) => {
        if (values.every((v) => v)) {
          if (that.paymentMethod === 4 || that.paymentMethod === 5) {
            var udid = uuid();
            var guestUserId = uuid();
            this.guestUserId = guestUserId;
            localStorage.setItem(
              "giftCheckoutData",
              JSON.stringify(that.$data)
            );

            let payment = new DefaultPaymentHandler();
            that.proccessing = true;
            payment
              .PrepairPaymentUrl({
                PaymentType: that.paymentMethod === 4 ? 0 : 1,
                storeId: that.storeid,
                orderId: udid,
                userId: that.user ? that.user.id : guestUserId,
                totalAmount: that.getTotalPrice,
                storename: that.$route.params.storename,
                isMobile: that.isMobile(),
              })
              .then((result) => {
                window.location.href = result.data;
              })
              .catch((error) => {
                that.proccessing = false;
                that.error = error.message;
              });
          } else that.processPayment();
        } else {
          setTimeout(() => {
            $$(that.$el).find("[aria-invalid=true]").focus();
          }, 10);
        }
      });
    },

    processPayment(savedUdid, savedGuestUserId) {
      this.proccessing = true;
      this.error = false;
      let payment = new DefaultPaymentHandler();
      //
      let udid = savedUdid || uuid();
      this.registerNew = false;

      //generate token and save in db
      let cardModel = this.createCardModel();
      if (this.saveCard) {
        this.StoreCard(cardModel);
      }
      if (this.registerNew) {
        this.signUserUp({ email: this.detailModel.Email, password: "123456" });
      }
      let userModel = this.createUserModel();

      let orderInfo = {
        orderType: this.orderType,
      };
      let guestUserId = savedGuestUserId || uuid();
      payment
        .MakePayment(
          udid,
          cardModel,
          userModel,
          this.currentStoreDoc,
          orderInfo,
          guestUserId,
          this.paymentMethod,
          true,
          this.giftUsedCoupons,
          null,
          savedUdid ? true : false
        )
        .then((res) => {
          this.proccessing = false;
          if (res.data.Success === true) {
            this.clearGiftCart();
            localStorage.removeItem("giftCheckoutData");
            this.error = "";
            this.navigateSuccess();
          } else {
            if (res.data.Status.Code == 1001)
              this.error = res.data.Status.Message;
          }
        })
        .catch(() => {
          this.proccessing = false;
          this.error = this.$t("message.apiTimeoutMessage", {
            msg: `<a class="sc-jZIEzD edcGpI" href="mailto:support@abacus.co" title="mailto:support@abacus.co">support@abacus.co</a>`,
          });
        });
    },
    StoreCard(cardModel) {
      storeCard(this.user.id, cardModel, this.storeid);
    },

    navigateSuccess() {
      this.$router.push({
        name: "thankyougift",
        params: {
          storeid: this.storeid,
          storename: this.$route.params.storename,
          isGift: true,
        },
      });
    },
    payByWechatMode() {
      this.paymentMethod = 5;
      // this.clearCardType();
    },
    payByAlipayMode() {
      this.paymentMethod = 4;
      // this.clearCardType();
    },
    payByCardMode() {
      this.paymentMethod = 1;
      if (this.paymentModel.SelectedCard) {
        // var card = this.paymentModel.SelectedCard.CardType;
        // this.setCardNumber(card);
      }
    },
    createUserModel() {
      var userID = "";
      var firstName = "";
      var lastName = "";
      var displayName = "";
      var phone = "";
      var email = "";
      var isguest = true;

      firstName = firstName || this.detailModel.FirstName || "";
      lastName = lastName || this.detailModel.LastName || "";
      email = email || this.detailModel.Email || "";
      phone = this.detailModel.Phone || "";
      displayName = firstName + " " + lastName;
      return {
        IsGuest: isguest,
        ID: userID,
        FirstName: firstName.trim(),
        LastName: lastName.trim(),
        DisplayName: displayName.trim(),
        Phone: phone.trim(),
        Email: email.trim(),
      };
    },
    createCardModel() {
      let exDate = this.paymentModel.ExpireDate.split("/");
      let isToken = false;

      let useCard = !isToken && this.paymentMethod == 1;
      return {
        exclude: !useCard,
        isToken: isToken,
        token: isToken ? this.paymentModel.SelectedCard.CardIdentifier : "",
        cvc: this.paymentModel.CVV,
        expMonth: exDate[0],
        expYear: useCard ? exDate[1] : "",
        number: this.paymentModel.CardNumber,
        holder: this.paymentModel.CardHolder.trim(),
      };
    },
  },
};
